import { axios } from './axios.js';

export async function addTaskForChatAttachments(orgId, name) {
  try {
    const response = await axios.post('/chat/attachments', {
      orgId: orgId,
      name: name,
    });

    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function uploadMessagesForAI(payload) {
  try {
    const response = await axios.post('/chat/process-messages', payload);

    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function deleteRoom(roomId) {
  try {
    const response = await axios.delete(`/chat/${roomId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
}
